/* eslint-disable max-len */
import * as React from 'react';
import { Tooltip, TooltipDirections } from 'ui/common/tooltip/tooltip';
import styles from './lock-text.scss';

export interface LockTextProps {
  text: string;
  bgColor?: string;
}

export const LockText: React.FC<LockTextProps> = ({ text, bgColor }) => {

  return <Tooltip title={text} className={styles.tooltip} direction={TooltipDirections.top}>
    <svg viewBox="0 0 10 40" height="2rem" width="1.8rem">
      <path fill={bgColor || '#cdcbcb'} transform="translate(-8,6)" d="M 15 2 C 11.154545 2 8 5.1545455 8 9 L 8 11 L 6 11 C 4.9 11 4 11.9 4 13 L 4 25 C 4 26.1 4.9 27 6 27 L 24 27 C 25.1 27 26 26.1 26 25 L 26 13 C 26 11.9 25.1 11 24 11 L 22 11 L 22 9 C 22 8.2047619 21.890601 7.4100849 21.648438 6.6835938 A 1.0001 1.0001 0 0 0 21.630859 6.6347656 C 20.590278 3.9754991 18.035897 2 15 2 z M 15 4 C 17.156184 4 18.991314 5.4178066 19.755859 7.3476562 C 19.908334 7.8171537 20 8.4064272 20 9 L 20 11 L 10 11 L 10 9 C 10 6.2454545 12.245455 4 15 4 z" />
    </svg>
  </Tooltip>;
};

LockText.displayName = 'LockText';
